/** Client-side mirror of backend dedupe — one row per AttributeName. */
export function dedupeInspectionAttributes(rows: any[]): any[] {
	if (!rows || rows.length === 0) return [];

	const byName = new Map<string, any>();

	for (const row of rows) {
		const name = row.AttributeName;
		if (!name) continue;

		const existing = byName.get(name);
		if (!existing) {
			byName.set(name, row);
			continue;
		}

		byName.set(name, pickPreferredAttribute(existing, row));
	}

	return Array.from(byName.values());
}

export function findAttributeByName(attributes: any[], attributeName: string): any | undefined {
	const matches = attributes.filter((attr) => attr.AttributeName === attributeName);
	if (matches.length === 0) return undefined;
	if (matches.length === 1) return matches[0];
	return pickPreferredAttribute(...matches);
}

export function getAttributeValue(attributes: any[], attributeName: string): string {
	const attr = findAttributeByName(attributes, attributeName);
	if (!attr) return "";
	const val = attr.AttributeValue;
	return val !== null && val !== undefined ? String(val) : "";
}

function pickPreferredAttribute(...candidates: any[]): any {
	return candidates.reduce((best, current) => {
		if (!best) return current;

		if (!best.Id && current.Id) return current;
		if (best.Id && !current.Id) return best;

		const bestHasValue = hasUsableValue(best);
		const currentHasValue = hasUsableValue(current);
		if (currentHasValue && !bestHasValue) return current;
		if (bestHasValue && !currentHasValue) return best;

		return current;
	});
}

function hasUsableValue(attr: any): boolean {
	if (attr.Qty !== null && attr.Qty !== undefined && Number(attr.Qty) > 0) return true;
	if (attr.CalculatedValue !== null && attr.CalculatedValue !== undefined && Number(attr.CalculatedValue) > 0) {
		return true;
	}
	const val = attr.AttributeValue;
	return val !== null && val !== undefined && String(val).trim() !== "";
}
